import { collabStateManager } from '@databases/collab-state-manager';
import { createPresenceEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export function createPresenceEffectFeature({
  contentId,
}: {
  contentId: string;
}): SelectionEffectFeature {
  void collabStateManager;
  return {
    key: SelectionFeatureKeys.PRESENCE_EFFECT,
    type: 'effect',
    // Always active — presence is read-only collaboration state.
    factory: () => {
      return createPresenceEffect({
        contentId,
        selectionsApi: getService('SelectionsApi'),
        collabStateManager,
      });
    },
  };
}
